
import { Vue } from "vue-class-component";
import StorageService from "../services/StorageService";
import ApiService from "../services/ApiService";
import { useStore } from "vuex";

export default class LoginForm extends Vue {
  private storageService = new StorageService();
  private apiService = new ApiService();
  globalStore = useStore();
  username = "";
  password = "";
  loginButtonEnabled = true;

  async login() {
    this.loginButtonEnabled = false;

    // Send the user for a route that requires authentication
    // This way keycloak will prompt the user to provide the credentials
    await this.$router.push("home");
  }
}
